// extracted by mini-css-extract-plugin
export default {"sign":"EtXVdG1L"};